const sys = {
  GENERIC_ERROR: {
    message: 'Ocorreu um erro',
    field: 'message',
    code: 'SYS_1'
  }
};

module.exports = sys;
